import React from "react"
import ImageMarkerFeatureComponent from "@csrc/components/FeaturesComponents/modules/checklist/image-marker/ImageMarkerFeatureComponent"
import RepeaterFeatureComponent
  from "@csrc/components/FeaturesComponents/modules/checklist/repeater/RepeaterFeatureComponent"
import ImportChecklistComponent
  from "@csrc/components/FeaturesComponents/modules/checklist/template/import-checklist-component"
import AddGlobalItemFeatureComponent from "@csrc/components/FeaturesComponents/modules/checklist/global-template/add-global-item/AddGlobalItemFeatureComponent"
import AddGlobalPageFeatureComponent from "@csrc/components/FeaturesComponents/modules/checklist/global-template/add-global-page/AddGlobalPageFeatureComponent"
import AddGlobalItemInPageRootFeatureComponent from "@csrc/components/FeaturesComponents/modules/checklist/global-template/add-global-item-in-page-root/AddGlobalItemInPageRootFeatureComponent"

const featuresArr = {
  imageMarker: {
    key: 'ckl_image_marker',
    title: `checklist.info.imageMarker`,
    component: <ImageMarkerFeatureComponent />,
    properties: ['']
  },
  importChecklist: {
    key: 'ckl_create_checklist_from_csv',
    title: `checklist.actions.importChecklist`,
    component: <ImportChecklistComponent />,
    properties: ['Import your checklists']
  },
  repeater: {
    key: 'ckl_repeater',
    title: `checklist.inputs.repeater`,
    component: <RepeaterFeatureComponent />,
    properties: ['']
  },
  calculation: {
    key: 'ckl_calculation',
    title: `checklist.questions.calculation`,
    component: <RepeaterFeatureComponent />,
    properties: ['']
  },
  globalListItem: {
    key: 'ckl_global_list',
    title: `checklist.questions.global_list`,
    header: "Global lists helps you to Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    properties: ['']
  },
  rule: {
    key: 'ckl_rule',
    title: `checklist.inputs.rules`,
    header: "",
    properties: ['']
  },
  global_templates_list: {
    key: 'ckl_global_item',
    title: `checklist.nav.globalItems`,
    header: "",
    properties: ['']
  },
  ckl_add_global_item: {
    key: 'ckl_global_item',
    localKey: 'ckl_add_global_item',
    title: `checklist.nav.globalItem`,
    // component: <AddGlobalItemFeatureComponent />,
    header: "",
    properties: ['']
  },
  ckl_add_global_page: {
    key: 'ckl_global_item',
    localKey: 'ckl_add_global_page',
    title: `checklist.nav.globalItem`,
    // component: <AddGlobalPageFeatureComponent />,
    header: "",
    properties: ['']
  },
  ckl_add_global_item_in_page_root: {
    key: 'ckl_global_item',
    localKey: 'ckl_add_global_item_in_page_root',
    title: `checklist.nav.globalItem`,
    // component: <AddGlobalItemInPageRootFeatureComponent />,
    header: "",
    properties: ['']
  },
  ckl_replace_with_global_item: {
    key: 'ckl_global_item',
    localKey: 'ckl_replace_with_global_item',
    title: `checklist.nav.globalItem`,
    // component: <AddGlobalItemInPageRootFeatureComponent />,
    header: "",
    properties: ['']
  },
  ckl_convert_to_global_item: {
    key: 'ckl_global_item',
    localKey: 'ckl_convert_to_global_item',
    title: `checklist.nav.globalItem`,
    // component: <AddGlobalItemInPageRootFeatureComponent />,
    header: "",
    properties: ['']
  }
}

export default featuresArr